/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  Avatar,
  Button,
  Card,
  Collapse,
  Dropdown,
  Image,
  Progress,
  Tag,
  Tooltip,
} from "antd";
import { SelectArrow } from "../../../../atoms/CustomIcons";

import UnscheduleIcon from "../../../../atoms/CustomIcons/UnscheduleIcon";
import RescheduleIcon from "../../../../atoms/CustomIcons/RescheduleIcon";
import MarkAsNotCompleted from "../../../../atoms/CustomIcons/MarkAsNotCompleted";
import CancelIcon from "../../../../atoms/CustomIcons/CancelIcon";
import { MoreOutlined } from "@ant-design/icons";

function PopOverCard(props: any) {
  const { visitData, setButton1, setButton2, button1, button2 } = props;

  const itemsScheduled = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <RescheduleIcon /> Reschedule
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <UnscheduleIcon /> Unschedule
        </Button>
      ),
    },
  ];

  const itemsPending = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <MarkAsNotCompleted /> Mark as not completed
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <RescheduleIcon /> Reschedule partially
        </Button>
      ),
    },
  ];

  const itemsCompleted = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <MarkAsNotCompleted /> Mark as not completed
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <RescheduleIcon /> Reschedule partially
        </Button>
      ),
    },
  ];

  const itemsInProgress = [
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <CancelIcon /> Cancel completion
        </Button>
      ),
    },
  ];

  let cardClass = "default_tag";
  if (visitData?.status === "completed") {
    cardClass += " grey_tag";
  } else if (visitData?.status === "confirmation_pending") {
    cardClass += " blue_tag";
  } else if (visitData?.status === "in_progress") {
    cardClass += " purple_tag";
  } else if (visitData?.status === "scheduled") {
    cardClass += " mint_tag ";
  }
  return (
    <div className="visitDataCard">
      <div className="visitCardHeader">
        <h3>Visit details</h3>

        <div
          className="visitHeaderRight"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
          }}
        >
          {button1 && button2 ? (
            <Tag className="default_tag grey_tag"> Completed </Tag>
          ) : (
            <Tag className={cardClass}>
              {" "}
              {visitData?.status
                ?.replace("_", " ")
                ?.replace(/^\w/, (c: string): string => c.toUpperCase())}{" "}
            </Tag>
          )}

          <Dropdown
            menu={{
              items:
                visitData?.status === "scheduled"
                  ? itemsScheduled
                  : visitData?.status === "confirmation_pending"
                  ? itemsPending
                  : visitData?.status === "in_progress"
                  ? itemsInProgress
                  : itemsCompleted,
            }}
            trigger={["click"]}
            placement="bottomRight"
            className="actionButton"
          >
            <Button
              onClick={(e) => {
                e.stopPropagation();
              }}
              onKeyDown={(e) => e.stopPropagation()}
              className="only_icon"
              icon={<MoreOutlined />}
            />
          </Dropdown>
        </div>
      </div>

      <div className="visitAddress">
        <div className="addressImage">
          <Avatar size={40} src="/images/dummy/address-dummy.svg" />
          <div className="addressInfo">
            <h5>{visitData?.title}</h5>
            <div className="addressLabel">
              <Image
                src="/images/estimate/address-icon.svg"
                preview={false}
                width={12}
              />
              <p>{visitData?.address}</p>
            </div>
          </div>
          <div className="summaryIcon">
            <Tooltip
              title={
                <>
                  <span>Property note:</span>
                  <p>
                    Two dogs in backyard – ensure gate is closed at all times.
                  </p>
                </>
              }
              getPopupContainer={(trigger) =>
                trigger.parentElement || document.body
              }
              arrow={false}
              placement="bottomLeft"
            >
              <Image src="/images/estimate/summary-icon.svg" preview={false} />
            </Tooltip>
          </div>
        </div>
        <div className="visitWrapper">
          <div className="visitTiming">
            <label>Visit time:</label>
            <h4>
              {visitData?.startTime} - {visitData?.endTime}
            </h4>
          </div>
          <div className="visitTiming">
            <label>Contract:</label>
            <h4>{visitData?.contract}</h4>
          </div>
        </div>

        <Card className="preferCard">
          <p>Preferred visit time:</p>
          <div className="preferInfo">
            <div className="preferLeft">
              <Tag>Mo</Tag>
              <Tag>Tu</Tag>
              <Tag>We</Tag>
            </div>
            <div className="preferRight">
              <Tag>10:00 AM - 12:00 PM</Tag>
            </div>
          </div>
        </Card>

        <Collapse
          accordion
          items={[
            {
              key: "1",
              label: (
                <>
                  <> Work orders </>
                  <Tag
                    style={{
                      height: "20px",
                      width: "20px",
                      backgroundColor: "#D0F2E8",
                      border: "unset",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    2
                  </Tag>
                </>
              ),
              children: (
                <div className="popOverCollapseContent">
                  <Card>
                    <div className="contentTitle">
                      {visitData?.status === "completed" && (
                        <Image
                          src="/images/estimate/selected-icon.svg"
                          preview={false}
                        />
                      )}
                      {visitData?.status === "confirmation_pending" && (
                        <Image
                          src="/images/estimate/selected-icon.svg"
                          preview={false}
                        />
                      )}
                      {visitData?.status === "in_progress" && (
                        <Image
                          src="/images/schedule/popup/indicator.svg"
                          preview={false}
                        />
                      )}
                      {visitData?.status === "scheduled" && (
                        <Image
                          src="/images/schedule/popup/indicator.svg"
                          preview={false}
                        />
                      )}

                      <span>Weekly service</span>
                    </div>
                    <div className="contentTime">
                      <div className="timeSpan">
                        <Image
                          src="/images/estimate/clock-icon.svg"
                          preview={false}
                          style={{ height: "14px", width: "14px" }}
                        />
                        21m
                        {visitData?.status !== "scheduled" && (
                          <Progress
                            strokeColor="#00A07D"
                            percent={50}
                            size={["75%", 3]}
                            style={{
                              marginLeft: "4px",
                              display: "inline-flex",
                            }}
                          />
                        )}
                      </div>
                      {visitData?.status === "confirmation_pending" && (
                        <div>
                          <Button
                            className={
                              button1
                                ? "outlined-btn btn-sm"
                                : "mint-btn btn-sm"
                            }
                            disabled={button1}
                            onClick={() => setButton1(true)}
                          >
                            {button1 ? "Completed" : "Confirm"}
                          </Button>
                        </div>
                      )}
                      {visitData?.status === "completed" && (
                        <div>
                          <Button className="outlined-btn btn-sm" disabled>
                            Completed
                          </Button>
                        </div>
                      )}
                    </div>
                  </Card>
                  <Card>
                    <div className="contentTitle">
                      {visitData?.status === "completed" && (
                        <Image
                          src="/images/estimate/selected-icon.svg"
                          preview={false}
                        />
                      )}
                      {visitData?.status === "confirmation_pending" && (
                        <Image
                          src="/images/estimate/selected-icon.svg"
                          preview={false}
                        />
                      )}
                      {visitData?.status === "in_progress" && (
                        <Image
                          src="/images/schedule/popup/indicator.svg"
                          preview={false}
                        />
                      )}
                      {visitData?.status === "scheduled" && (
                        <Image
                          src="/images/schedule/popup/indicator.svg"
                          preview={false}
                        />
                      )}
                      <span>Pruning Services</span>
                    </div>
                    <div className="contentInfo">
                      <div className="contentTime">
                        <div className="timeSpan">
                          <Image
                            src="/images/estimate/clock-icon.svg"
                            preview={false}
                            style={{ height: "14px", width: "14px" }}
                          />
                          16m
                          {visitData?.status !== "scheduled" && (
                            <Progress
                              strokeColor="#00A07D"
                              percent={50}
                              size={["75%", 3]}
                              style={{
                                marginLeft: "4px",
                                display: "inline-flex",
                              }}
                            />
                          )}
                        </div>
                        {visitData?.status === "confirmation_pending" && (
                          <div>
                            <Button
                              className={
                                button2
                                  ? "outlined-btn btn-sm"
                                  : "mint-btn btn-sm"
                              }
                              disabled={button2}
                              onClick={() => setButton2(true)}
                            >
                              {button2 ? "Completed" : "Confirm"}
                            </Button>
                          </div>
                        )}
                        {visitData?.status === "completed" && (
                          <div>
                            <Button className="outlined-btn btn-sm" disabled>
                              Completed
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Card>
                </div>
              ),
            },
          ]}
          expandIcon={({ isActive }) => (
            <SelectArrow style={{ rotate: isActive ? "265px" : "90px" }} />
          )}
        />
      </div>
    </div>
  );
}

export default PopOverCard;
